/**
 * Shared API client + auth token helpers.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'jobcongo_token';
const USER_KEY = 'jobcongo_user';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
export const setStoredUser = (u) => {
  if (u) localStorage.setItem(USER_KEY, JSON.stringify(u));
  else localStorage.removeItem(USER_KEY);
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const logout = () => {
  setToken(null);
  setStoredUser(null);
};

export const centsToUsd = (c) => {
  const v = (Number(c || 0) / 100);
  return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
export const usdToCents = (v) => Math.round(Number(v || 0) * 100);

export const fmtUSD = (cents) => `${centsToUsd(cents)} $`;

export const PAYMENT_METHODS = [
  { id: 'airtel_money', label: 'Airtel Money', desc: 'Mobile Money RDC' },
  { id: 'orange_money', label: 'Orange Money', desc: 'Mobile Money RDC' },
  { id: 'mpesa', label: 'M-Pesa (Vodacom)', desc: 'Mobile Money RDC' },
  { id: 'africell', label: 'Africell Money', desc: 'Mobile Money RDC' },
  { id: 'visa', label: 'Carte Visa', desc: 'Diaspora & international' },
  { id: 'wire', label: 'Virement bancaire', desc: 'Rawbank, Equity BCDC, FBN, TMB…' },
  { id: 'pi_network', label: 'Pi Network', desc: 'Paiement en Pi (crypto)' },
];
